import 'whatwg-fetch';
import { api, basicPayload, methodToSla, sellerIdFood, maxItemsExpress, expressFlag } from 'config'
import LoginService from 'services/Login/';
import PubSub from 'services/PubSub/';
import StorageService from 'services/StorageService/';
import TagManagerService from 'services/TagManager';
import SalesChannel from 'services/SalesChannel';
import AddressActions from 'actions/Address';
import AddressService from 'services/Address/';
import WalletService from 'services/Wallet';
import { cleanAddress, cloneArray } from 'utils'
import { updateTabs } from 'utils';
import { walletPaymentsName, paymentsName } from 'config/index';
import Log from 'services/Log';
import ProductFactory from 'factories/Products';
import AddressFactory from 'factories/Address';
import CartActions from 'actions/Cart';
import Day from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import { actionsType } from "config/constants"
import VtexEvent from 'services/VtexEvent'
import NewRelicService from 'services/NewRelic'

let attemptAtService = {
    init: 0,
    get: 0,
    add: 0,
    update: 0,
    remove: 0,
    sc: 0
};

let oldOrderForm = null;

let controllersRequest = {
    replacementCriteria : null
}

let listItems = {};
let listPromiseCount = 0;
let listPromise = [];
let isPromiseWorking = false;

// Configure Seller
const _addSellerId = (items) => {
    if (Array.isArray(items)) {
        items = items.map(item => {
            item['seller'] =  item['seller'] || sellerIdFood
            return item;
        });
    } else {
        items['seller'] =  items['seller'] || sellerIdFood
    }
    return items;
}

let cachePromise = {
    currentCart: null
}
// Check Current Cart
const getCurrentCart = () => {
    let orderFormId = StorageService.getItem('orderFormId');
    if(cachePromise.currentCart){
        return Promise.resolve(cachePromise.currentCart);
    }
    if (orderFormId && orderFormId.length > 15) {
        cachePromise.currentCart = getOrderForm(orderFormId);
    } else {
        cachePromise.currentCart = initOrderForm();
    }
    return cachePromise.currentCart;
}

const getOldAddress = () => {
    const method = SalesChannel.getMethodName();

    if(method !== 'seller-1-sla-DespachoaDomicilio'){
        return Promise.resolve(false);
    }

    return CartService.getCurrentCart().then((orderForm) => {
        return orderForm.shippingData.address || false;
    });
}

const validateAddress = (orderForm) => {

    const method = StorageService.getItem('preselected_shipping_method');
    const storeName = StorageService.getItem('store_name');
    const sc = StorageService.getSecureItem('sales_channel');
    const oldAddress = StorageService.getSecureItem('address');

    const currentAddress = (orderForm && orderForm.shippingData) ? orderForm.shippingData.address : null;
    if((!currentAddress) && method !== 'seller-1-sla-DespachoaDomicilio') {
        return AddressActions.setDeliveryMode(method, storeName, sc, oldAddress, false);
    }

    if((!currentAddress && oldAddress) && method === 'seller-1-sla-DespachoaDomicilio') {

        return AddressService.applyAddress(oldAddress, [oldAddress], method).then(newOrderForm => {
            if (newOrderForm) {
                return AddressService.setDeliveryMode(method, storeName, sc, false, false).then((_orderForm) => {
                    return {...newOrderForm, ..._orderForm}
                });
            }
        });
    }
    return Promise.resolve(orderForm);
}

const changeOrdination = (orderFormId) => {
    let payload = basicPayload;
    payload.criteria = "add_time";
    payload.ascending = false;

    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }

    const salesChannel = SalesChannel.getSalesChannel();

    return fetch(api.orderForm + `/orderform/${orderFormId}/itemsOrdination?sc=${salesChannel}`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
    })
}

const dispatchModalNote = (productData) => {
    if(!(productData && productData.categories.findIndex(cat => cat.includes('Vestuario')) !== -1)) return false;
    let orderInfoData = StorageService.getItem('replacementCriteria');
    if(orderInfoData) {
        orderInfoData = JSON.parse(orderInfoData);
    }
    setTimeout(() => PubSub.dispatch('add_notes_open', {
        products: productData,
        note: (orderInfoData && orderInfoData[productData.id]) ? orderInfoData[productData.id].note : '',
        criteriaId: 6,
        placeholder: 'Escríbenos las indicaciones para este producto (talla, color o modelo)',
    }),0);
}

// Init a Cart
const initOrderForm = () => {

    let _orderForm = {};
    return fetch(api.orderForm + `/orderForm`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "postalCode": null,
            "country": "CL",
            "items": [],
            "selectedSla": null
        }),
    })
        .then(results => results.json())
        .then(results => _validationError('init', ()=> initOrderForm(), results))
        .then(results => _verfifyPayment(results))
        .then(orderForm => {
            cachePromise.currentCart = null;
            _orderForm = orderForm;
            if(orderForm && orderForm.itemsOrdination && orderForm.itemsOrdination.criteria === 'add_time' && !orderForm.itemsOrdination.ascending) return Promise.resolve(orderForm);
            if(!(orderForm && orderForm.orderFormId)) return false;
            oldOrderForm = oldOrderForm ? Object.assign(oldOrderForm, orderForm) : orderForm;
            return changeOrdination(orderForm.orderFormId).then(results => results.json());
        })
        .then((response) => {
            if(!response || response.status == 500) return oldOrderForm;
            StorageService.setItem('orderFormId', response['orderFormId']);
            LoginService.createProfileData(response['orderFormId']);
            return response;
        })
        .then(results => {
            _orderForm = _orderForm ? Object.assign(_orderForm, results) : results;
            oldOrderForm = oldOrderForm ? Object.assign(oldOrderForm, _orderForm) : _orderForm;
            return _orderForm;
        })
        .catch(() => _validationError('init', ()=> initOrderForm()));
}

// Given an orderFormId get cart
const getOrderForm = (orderFormId) => {
    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }
    let _orderForm = {};
    return fetch(api.orderForm + `/orderform/${orderFormId}`, {
        headers
    })
        .then(results => results.json())
        .then(results => _validationError('get', ()=> getOrderForm(orderFormId), results))
        .then(results => _verfifyPayment(results))
        .then(orderForm => {
            if(orderForm && orderForm.itemsOrdination && orderForm.itemsOrdination.criteria === 'add_time') return Promise.resolve(orderForm);
            if(!(orderForm && orderForm.orderFormId)) return false;
            _orderForm = orderForm;
            return changeOrdination(orderForm.orderFormId).then(results => results.json());
        }).then(orderForm => {
            cachePromise.currentCart = null;
            if(!orderForm || orderForm.status == 500) return oldOrderForm;
            if(orderForm && (typeof window !== 'undefined' && window.location.href.indexOf('/checkout') === -1) && orderForm.paymentData.payments.length > 0) {
                return setPayment([]);
            }
            _orderForm = _orderForm ? Object.assign(_orderForm, orderForm) : orderForm;
            return _orderForm;
        })
        .then(orderForm => {
            if(!orderForm) return false;
            oldOrderForm = oldOrderForm ? Object.assign(oldOrderForm, orderForm) : orderForm;
            return orderForm;
        })
        .catch(() => _validationError('get', ()=> getOrderForm(orderFormId)));
}

const _validationError = (name, callback, results = null) => {
    if(!(results && !(results.status && (results.message || results.statusMessage)))){
        return _attemptByError(name, callback);
    }

    attemptAtService[name] = 0;
    return results;
}

const _attemptByError = (name, callback) => {
    attemptAtService[name] = attemptAtService[name] + 1;

    if(attemptAtService[name] > 3){
        attemptAtService[name] = 0;
        return false;
    } else{
        return callback();
    }
}

const _returnOldOrderForm = (orderform) => {
    if(!orderform){
        oldOrderForm.isOld = true;
        return oldOrderForm;
    }
    return orderform;
}

const getOldOrderForm = () => {
    return oldOrderForm;
}

const __addItems = (items) => {
    let itemsAdd = _addSellerId(items);

    const excludeItems = [];

    itemsAdd = itemsAdd.map(item => {
        let index = [];

        if(oldOrderForm){
            oldOrderForm.items.map((element,i) => {
                if(element.id === item.id) {
                    index.push(i);
                }
            });
        }

        if(index.length > 1){
            excludeItems.push({index: index[1], quantity: 0});
        }

        if(index.length > 0){
            return {index: index[0], quantity: item.quantity}
        }

        return item;
    }).concat(excludeItems);

    StorageService.removeItem('removed_items');

    return itemsAdd;
}

const addItems = (items) => {
    return _addListPromise('add', items);
}

const _addListPromise = (action, items) => {
    if(!listItems[action]){
        listItems[action] = [];
    }

    listItems[action] = listItems[action].concat(items);

    return new Promise(resolve => {
        if(!listPromise[listPromiseCount]){
            listPromise[listPromiseCount] = [];
        }

        listPromise[listPromiseCount].push(resolve);

        if(!isPromiseWorking){
            _runNextPromise();
        }
    });
}

const _runNextPromise = () => {
    isPromiseWorking = true;
    const newList = {...listItems};
    listItems = {};

    let isData = false;

    for(let key in newList){
        if(newList[key].length > 0) isData = true;
    }

    if(!isData){
        isPromiseWorking = false;
        return false;
    }

    const listId = listPromiseCount;
    listPromiseCount++;

    return __getCurrentCartToUpdateItems(newList).then(orderForm => {
        __updateItems(orderForm, newList).then(data => {
            if(data && data.items) {
                VtexEvent.updateCart(data.items);
            }
            listPromise[listId].map(resolve => {
                resolve(data);
            });
            listPromise[listId] = null;
            isPromiseWorking = false;
            _runNextPromise();
        });
    });
}

const __getCurrentCartToUpdateItems = (items) => {
    const add = items.add && items.add.length > 0;
    const update = items.update && items.update.length > 0;
    const remove = items.remove && items.remove.length > 0;
    const removeAll = items.removeAll && items.removeAll.length > 0;

    if(oldOrderForm && (removeAll || (add && !(update || remove)))){
        return Promise.resolve(oldOrderForm);
    }

    return getCurrentCart();
}

const __updateItems = (orderForm, items) => {
    const orderFormId = StorageService.getItem('orderFormId');

    let changeItems = [];

    if (!items) {
        return new Promise(resolve => resolve(orderForm));
    }

    if(items.removeAll && items.removeAll.length > 0){
        return _removeAllItems();
    }

    if(items.add && items.add.length > 0){
        changeItems = changeItems.concat(__addItems(items.add));
    }

    if(items.update && items.update.length > 0){
        changeItems = changeItems.concat(_updateItems(orderForm, items.update));
    }

    if(items.remove && items.remove.length > 0){
        changeItems = changeItems.concat(_removeItems(orderForm, items.remove));
    }

    if (changeItems.length === 0) {
        return new Promise(resolve => resolve(orderForm));
    }

    const oldItemsMeasure = [];

    if(oldOrderForm){
        oldOrderForm.items.map(element => {
            if(element.measurementUnit === 'kg'){
                oldItemsMeasure.push(element.measurementUnit);
            }
        });
    }

    return _updateOrderForm(orderFormId, changeItems)
        .then(results => _validationError('add', ()=> __updateItems(items), results))
        .then(newOrderForm => {
            if(newOrderForm && newOrderForm.items){
                oldOrderForm = Object.assign(oldOrderForm, newOrderForm);
            }
            return newOrderForm;
        })
        .then(newOrderForm => {
            const itemsMeasure = [];

            newOrderForm.items.filter(item => {
                if(item.measurementUnit === 'kg'){
                    itemsMeasure.push(item.measurementUnit);
                }
            });

            if(itemsMeasure.length === 1 && !oldItemsMeasure.length) {
                PubSub.dispatch('open_snackbar',{
                    Subtitle:'En los productos a granel, si no encontramos el peso cercano a lo solicitado, te <strong>llamaremos</strong> para que nos indiques cómo quieres ajustarlo.',
                    timer: 10000,
                    type: 'granelProducts'
                });
            }

            return _returnOldOrderForm(newOrderForm)
        })
        .catch(() => _validationError('add', ()=> __updateItems(items)));
}

// Update item quantity in cart, if not found adds it
const _updateItems = (orderForm, items) => {
    let ids = [];

    let updatedItems = [];

    if(orderForm && orderForm.items && orderForm.items.length > 0){
        orderForm.items.forEach((x, index) => {
            items.forEach(item => {
                const itemToAdd = item.item;
                const quantity = item.quantity;
                if (x.id === itemToAdd.id && x.quantity === itemToAdd.quantity && ids.indexOf(itemToAdd.id) === -1) {
                    ids.push(itemToAdd.id);
                    updatedItems.push({
                        index,
                        quantity: quantity
                    });
                }
            });
        });
    }

    return updatedItems;
}

const updateQuantity = (item, quantity) => {
    return _addListPromise('update', [{
        item,
        quantity
    }]);
}

// Update item quantity in cart, if not found adds it
const _removeItems = (orderForm, items) => {
    let isRemoved = {};
    let removedItems = [];

    orderForm.items.forEach((x, index) => {
        items.forEach(itemToRemove => {
            if (x.id === itemToRemove.id && x.quantity === itemToRemove.quantity && !isRemoved[x.id]) {
                isRemoved[x.id] = true;
                removedItems.push({
                    index,
                    quantity: 0
                });
            }
        });
    });

    return removedItems;
}

const removeItem = (item) => {
    return _addListPromise('remove', item);
}

// Remove all items from Cart
const _removeAllItems = () => {
    const orderFormId = StorageService.getItem('orderFormId');

    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }

    return fetch(api.orderForm + `/orderform/${orderFormId}/items/removeAll`, {
        method: 'POST',
        headers,
        body: JSON.stringify({})
    })
        .then(data => data.json())
        .then(orderForm => {
            if(orderForm && orderForm.items){
                oldOrderForm = Object.assign(oldOrderForm, orderForm);
            }
            return orderForm;
        });
}

const emptyCart = () => {
    return _addListPromise('removeAll', 'all');
}

const purchase = (callback = ()=>{}) => {
    _sendPurchaseEventByNewRelic('init');

    CartService.getCurrentCart().then(orderForm => {
        const isCheckoutCompleted = CartService.getAllOrderFormStatus(orderForm);

        if(isCheckoutCompleted){
            let methodSelected = StorageService.getItem('preselected_shipping_method');
            if(methodSelected === 'seller-1-sla-Express') {
                CartService.shippingEstimate(orderForm.orderFormId, _expressTime()).then(()=> {
                    _purchase(orderForm, callback);
                });
            } else {
                _deleteShippingEstimate(orderForm.orderFormId).then(()=> {
                    _purchase(orderForm, callback);
                });
            }

        } else {
            if(typeof window !== 'undefined') window.location.reload();
        }
    }).catch(err => {
        Log.captureException(err);
        _failPayment(callback, false);
        return false;
    });
}

const _expressTime = () => {
    const oldOF = getOldOrderForm();

    const quantity = oldOF ? oldOF.items.reduce(function (oldValue, item) {
        return oldValue + item.quantity;
    }, 0) : 0;

    let deliveryTime = parseFloat(StorageService.getItem('delivery_time')) || 180;

    if(quantity > 30 && quantity <= 60){
        deliveryTime = deliveryTime + 20;
    }else if(quantity > 60 && quantity <= 90){
        deliveryTime = deliveryTime + 40;
    }else if(quantity > 90 && quantity <= 180){
        deliveryTime = deliveryTime + 85;
    }else if(quantity > 180 && quantity <= 300){
        deliveryTime = deliveryTime + 120;
    }

    return deliveryTime;
}

const _sendPurchaseEventByNewRelic = (status = '', data = null, action = null) => {
    try{
        NewRelicService.sendPageAction({
            action: action || 'purchase',
            payload: {
                status,
                orderId: data ? data.orderId : '',
                tId: data ? data.tId : '',
                redirectUrl: data ? data.redirectUrl : '',
                errorCode: data ? data.errorCode : '',
                paymentName: data ? data.paymentName : ''
            }
        });
    } catch (e){
        return false;
    }
}

const _purchase = (orderForm, callback) => {
    const paymentId = orderForm.paymentData.payments[0].paymentSystem
    const payment = orderForm.paymentData.paymentSystems.filter(item => item.stringId === paymentId)[0];
    const methodPayName = (payment.name === paymentsName.oneClick || payment.name === paymentsName.catOneClick) ? 'Crédito' : 'Débito';
    

    let pathName = typeof window !== 'undefined' ? window.location.pathname : '';
    TagManagerService.interaction('Hacer pedido', pathName, 'Resumen de compra');

    getPaymentURL(orderForm).then(data => {
        const addressId = orderForm.shippingData.address.addressId
        if(data && data.status === 404) {
            _failPayment(callback, false, data.status, methodPayName);
            return false
        }

        if(data && data.status === 403) {
            _sendPurchaseEventByNewRelic('open', null, 'modalValidationAddress');
            PubSub.dispatch(actionsType.MODAL.VALIDATION_CODE_CHECKOUT_OPEN, { addressId, orderFormId: orderForm.orderFormId })
            callback()
            return false
        }

        if(data && data.payload && data.payload.status){
            TagManagerService.interaction(methodPayName, data.payload.status, 'Errores transaction');
        }

        StorageService.setItem('purchaseOrderForm', orderForm.orderFormId);
        if(payment.name.indexOf(walletPaymentsName.oneClick) !== -1){
            if (!(data && data.tId && data.orderId && data.xChko)) {
                _failPayment(callback, false, 400, methodPayName);
                return false;
            }

            _sendPurchaseEventByNewRelic('generatedOrder', data);

            const {orderId, tId} = data;

            StorageService.setItem('wallet', orderForm.orderFormId);
            WalletService.purchase(tId).then(response => {
                if(response && response.internalCode === '200-0'){
                    _sendPurchaseEventByNewRelic('success', data);
                    if(typeof window !== 'undefined'){
                        window.location.href = `/checkout/orderPlaced/?og=${orderId}`;
                    }
                } else {
                    _failPayment(callback, true, response && response.internalCode, methodPayName);
                }
            });
        } else {
            if (!(data && data.redirectUrl)) {
                callback();
                return false;
            }
            _sendPurchaseEventByNewRelic('generatedOrder', data);
            _sendPurchaseEventByNewRelic('success', data);
            if(typeof window !== 'undefined') window.location.href = data.redirectUrl;
        }
    });
}

const _failPayment = (callback, isBank=false, errorCode = '', paymentName = '') => {
    _sendPurchaseEventByNewRelic('fail', {
        errorCode,
        paymentName
    }, isBank ? 'walletPayment' : null);
    callback();
    setTimeout(() => {
        if(isBank){
            TagManagerService.interaction(paymentName, errorCode, 'Errores payment');
            PubSub.dispatch(actionsType.MODAL.FAILED_PAYMENT_BANK_OPEN);

        }else {
            TagManagerService.interaction(paymentName, errorCode, 'Errores transaction');
            PubSub.dispatch('failed_payment_open');

        }
    }, 0);
}

const getPaymentURL = (orderForm = null) => {
    if(orderForm) return _getPaymentURL(orderForm);

    return getCurrentCart().then(currentOrderForm => {
        return _getPaymentURL(currentOrderForm);
    });
}

const _getPaymentURL = (orderForm) => {
    try{
        const payment = orderForm.paymentData.payments[0];
        const paymentId = payment.paymentSystem;
        const installmentOption = orderForm.paymentData.installmentOptions.filter(item => item.paymentSystem === paymentId)[0];
        const merchantSellerPayments = payment.merchantSellerPayments[0];
        const id = orderForm.orderFormId;

        const payload = {
            "referenceId": id,
            "savePersonalData": true,
            "optinNewsLetter": false,
            "value": installmentOption.installments[0].value,
            "interestValue": merchantSellerPayments.interestRate
        };

        return fetch(api.transaction + `/checkout/pub/orderform/transaction`, {
            method: 'POST',
            headers: {
                'x-api-key': api.apiKey,
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
        }).then(data => data.json());
    } catch (e) {
        return Promise.resolve(false);
    }
}

const shippingEstimate = (orderFormId, value) => {
    return fetch(api.orderForm + `/orderform/${orderFormId}/customData/shippingData/shippingEstimate`, {
        method: 'PUT',
        headers: {
            'x-api-key': api.apiKey,
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({value}),
    }).then(data => data.json()).then(_statusError).then(orderForm => {
        oldOrderForm = Object.assign(oldOrderForm, orderForm);
        return orderForm;
    });
}

const _deleteShippingEstimate = (orderFormId) => {
    return fetch(api.orderForm + `/orderform/${orderFormId}/customData/shippingData/shippingEstimate`, {
        method: 'DELETE',
        headers: {
            'x-api-key': api.apiKey,
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        },
    }).then(data => data.json());
}

const _updateOrderForm = (orderFormId, updatedItems, sc = null, notSC = false) => {
    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache'
    };

    if(token){
        headers.token = token;
    }

    let payload = basicPayload;
    payload.orderItems = updatedItems;

    if(!sc && !notSC){
        sc = SalesChannel.getSalesChannel();
    }

    return fetch(api.orderForm + `/orderform/${orderFormId}/items${sc ? '?sc=' + sc : ''}`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(payload),
    })
        .then(results => results.json())
        .then(results => _verfifyPayment(results))
        .then(orderForm => {
            if(orderForm && !orderForm.status){
                oldOrderForm = Object.assign(oldOrderForm, orderForm);
            }

            updateTabs();

            return orderForm;
        });
}

const clearLogisticInfo = (logisticsInfo) => {
    return cloneArray(logisticsInfo).map(item => {
        delete item.slas;
        delete item.deliveryChannels;
        return item;
    });
}

const applyingMethodInLogisticInfo = (logisticsInfo, method) => {
    if(!(logisticsInfo && logisticsInfo[0])) return logisticsInfo;

    method = methodToSla[method] || method;

    let selectedSla = 'Despacho a Domicilio';
    logisticsInfo[0].slas.map(sla => {
        if(sla.id.includes(method)) selectedSla = sla.id;
    });

    return logisticsInfo.map(item => {
        item.selectedSla = selectedSla;
        return item;
    });
}

const updateShippingData = (body) => {
    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }

    const orderFormId = StorageService.getItem('orderFormId');

    if(!body.expectedOrderFormSections){
        body.expectedOrderFormSections = basicPayload.expectedOrderFormSections;
    }
    return fetch(api.orderForm + `/orderform/${orderFormId}/shipping`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
    }).then(results => results.json()).then(_statusError).then(orderForm => {
        if(!(orderForm && orderForm.orderFormId)) return false;
        oldOrderForm = Object.assign(oldOrderForm, orderForm);
        if(body.address && body.address.addressId){
            StorageService.setItem('addressSelected', body.address.addressId);
        }
        return orderForm;
    });
}

const updateOrderForm = (updatedItems, sc = null, notSC = false) => {
    const orderFormId = StorageService.getItem('orderFormId');

    return _updateOrderForm(orderFormId, updatedItems, sc, notSC);
}

const setCupon = (cupon) => {
    const orderFormId = StorageService.getItem('orderFormId');

    let payload = basicPayload;
    payload.text = cupon;

    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }

    return fetch(api.orderForm + `/orderform/${orderFormId}/coupons`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
    }).then(results => results.json()).then(_statusError).then(orderForm => {
        oldOrderForm = Object.assign(oldOrderForm, orderForm);
        return orderForm;
    });
}

const goToCheckout = (history = null) => {
    const isLogged = LoginService.isLogged();

    const storeName = SalesChannel.getSalesChannelName();

    if (isLogged) {
        if (storeName && (storeName !== 'Jumbo Chile')) {
            NewRelicService.sendPageAction({
                action: 'goToCheckout'
            });

            const orderFormId = StorageService.getItem('orderFormId');
            StorageService.setItem('goToCart', orderFormId);

            if(!history && typeof window !== 'undefined'){
                window.location.href = `/_secure/cart`;
            } else {
                history.push(`/_secure/cart`);
            }

        } else {
            PubSub.dispatch('delivery_selector_open');
        }
    } else {
        PubSub.dispatch('login_open');
    }
}

const _verfifyPayment = (orderform) => {
    if(!orderform) return false;
    const goToCart = StorageService.getItem('goToCart');

    if(goToCart && goToCart === orderform.orderFormId){
        if(!(orderform.clientProfileData && orderform.clientProfileData.email) && !(orderform.shippingData && orderform.shippingData.address) && !(orderform.items && orderform.items.length > 0)){
            StorageService.removeItem('orderFormId');
            return getCurrentCart();
        }
    }

    return orderform;
}

const applySalesChannel = (sc, oldAddress = false, refresh = true) => {
    let isAllProducts = true;
    return getCurrentCart().then(orderForm => {
        if (!orderForm) return false;

        const items = orderForm.items.map((item, index) => {
            return {
                index,
                quantity: item.quantity
            };
        });

        if (!items[0]) {
            return Promise.resolve(oldOrderForm);
        }

        return _updateOrderForm(orderForm.orderFormId, items, sc)
            .then(results => _validationError('sc', ()=> applySalesChannel(sc, oldAddress, refresh), results))
            .then(orderform => _returnOldOrderForm(orderform))
            .then(results => {

                const newOrderForm = results;
                isAllProducts = _verifProdsNotAvailables((newOrderForm && newOrderForm.items) ? newOrderForm.items : [], oldAddress, refresh);

                return applyingSourceApp().then(() => {
                    return isAllProducts ? results : false;
                })
            })
            .catch(() => _validationError('sc', ()=> applySalesChannel(sc, oldAddress, refresh)));
    });
}

const _verifProdsNotAvailables = (newItems, oldAddress = false, refresh = true) => {

    if (newItems.length) {

        let itemsNotAvailables = newItems.filter((item) => item.availability === 'withoutStock')

        if (itemsNotAvailables && itemsNotAvailables.length) {

            let currentItems = newItems.map(item => {
                return {
                    id: item.id,
                    seller: item.seller,
                    quantity: item.quantity
                };
            });

            const oldSalesChannelInfo = SalesChannel.getOldSalesChannelInfo();

            PubSub.dispatch("lost_products_open", {
                currentItems: currentItems,
                itemsNotAvailables: itemsNotAvailables,
                oldSC: oldSalesChannelInfo.salesChannel,
                oldNameSC: oldSalesChannelInfo.salesChannelName,
                oldMethod: oldSalesChannelInfo.methodName,
                oldAddress: oldAddress,
                refresh
            });

            return false;
        }
    }
    return true;
}

const applyAddressSC = (address, sc, refresh, method, applyShippingData = true, oldAddress = null) => {

    return getCurrentCart().then(orderForm => {
        if (!orderForm) return false;
        let shippingData = orderForm.shippingData || null;

        address.complement = cleanAddress(address.complement);
        address.reference = cleanAddress(address.reference);
        if (shippingData && shippingData.address && shippingData.address.receiverName) {
            address.receiverName = shippingData.address.receiverName;
            oldAddress = orderForm.shippingData.address || oldAddress;
        } else {
            const userData = StorageService.getSecureItem('userData');
            address.receiverName = userData ? userData.firstName + ' ' + userData.lastName : '';
        }

        if(method && shippingData && shippingData.logisticsInfo && shippingData.logisticsInfo.length){
            shippingData.logisticsInfo = applyingMethodInLogisticInfo(shippingData.logisticsInfo, method);
        }

        if(!address.geoCoordinates && applyShippingData){
            address.geoCoordinates = address.geoCoordinate;
        }

        const body = {
            address: applyShippingData ? address : null,
            expectedOrderFormSections: basicPayload.expectedOrderFormSections,
            logisticsInfo: shippingData ? shippingData.logisticsInfo : [],
            pickupPoints: shippingData ? shippingData.pickupPoints : [],
            selectedAddresses: applyShippingData ? [address] : []
        };

        return fetch(api.orderForm + `/orderform/${orderForm.orderFormId}/shipping${sc ? '?sc='+sc : ''}`, {
            headers: {
                'x-api-key': api.apiKey,
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body),
        }).then(results => results.json())
            .then((newOrderForm)=> {
                if(!shippingData){
                    shippingData = newOrderForm.shippingData;
                }
                if(!(newOrderForm && newOrderForm.items)) return false;
                const isAllProducts = _verifProdsNotAvailables((newOrderForm.items) ? newOrderForm.items : [], oldAddress, refresh);
                if(shippingData.address && shippingData.address.addressId){
                    StorageService.setItem('addressSelected', shippingData.address.addressId);
                }
                return applyingSourceApp().then(() => {
                    newOrderForm.isAllProducts = isAllProducts;
                    return newOrderForm;
                })
            })
            .catch(() => {
                PubSub.dispatch('error_503');
                return false
            });

    });
}

const applyingSourceApp = (sc) => {
    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }

    const orderFormId = StorageService.getItem('orderFormId');
    return fetch(api.orderForm + `/orderform/${orderFormId}/customData/orderSource/sourceApp${sc ? '?sc=' + sc : ''}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ "value": "0" }),
    }).then(results => results.json()).then(_statusError).then(orderForm => {
        oldOrderForm = Object.assign(oldOrderForm, orderForm);
        return orderForm;
    });
}

const _statusError = (results) => {
    if (results.status) {
        /* eslint-disable no-console */
        console.error(results);
        /* eslint-enable no-console */
        if (results.status >= 500) {
            /* eslint-disable no-console */
            console.log(results);
            /* eslint-enable no-console */
            //PubSub.dispatch('error_503');
        }
        return false;
    }
    return results;
}

const sendMail = (orderId) => {

    if(!(orderId)) return Promise.resolve(false);

    return fetch(api.orders + `/order/sendmail/${orderId}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        }
    }).then(results => results.json()).then(results => {
        return results;
    });
}

const getOrderInfo = () => {
    const orderFormId = StorageService.getItem('orderFormId');
    const token = StorageService.getItem('sessionData');
    if(!(orderFormId && token)) return Promise.resolve(false);
    return fetch(api.orders + `/order/info/${orderFormId}`, {
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json',
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        }
    }).then(results => results.json()).then(results => {

        if(results.skuData){
            results.skuData = JSON.parse(results.skuData);
        }

        if(results.status && results.status === 404){
            results = false;
        }

        return results;
    });
}

const setOrderInfo = (data) => {
    let body = {...data};
    const orderFormId = StorageService.getItem('orderFormId');
    const token = StorageService.getItem('sessionData');
    if(!(orderFormId && token)) return Promise.resolve(false);

    body.id = orderFormId;
    body.skuData = JSON.stringify(body.skuData);
    if (controllersRequest.replacementCriteria) {
        controllersRequest.replacementCriteria.abort();
        controllersRequest.replacementCriteria = null;
    }
    let reqOptions = {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json',
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
        body: JSON.stringify(body)
    };

    if (typeof window !== 'undefined' && window.AbortController) {
        controllersRequest.replacementCriteria = new AbortController();
        reqOptions.signal = controllersRequest.replacementCriteria.signal;
    }

    return fetch(api.orders + `/order/info/${orderFormId}`, reqOptions).then(results => results.json()).then(() => {
        controllersRequest.replacementCriteria = null;
    }).catch(err => {
        controllersRequest.replacementCriteria = null;
        if(err.toString() === 'AbortError: The user aborted a request.') return false;
        return err;
    })
}

const setPayment = (data, sc) => {
    _sendPurchaseEventByNewRelic('init', null, 'setPayment');
    const orderFormId = StorageService.getItem('orderFormId');
    let body = {payments: data};
    const token = LoginService.getUserToken();
    let headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    };

    if(token){
        headers.token = token;
    }

    return fetch(api.orderForm + `/orderform/${orderFormId}/payments${sc ? '?sc=' + sc : ''}`, {
        headers,
        method: 'POST',
        body: JSON.stringify(body),
    }).then(results => results.json())
        .then((results) => {

            if((!results || results.status)) {
                _setPaymentError();
            } else {
                _sendPurchaseEventByNewRelic('success', null, 'setPayment');
            }

            return results;
        }).catch(() => {
            PubSub.dispatch('error_503');
            _setPaymentError();
            return false
        });
}

const _setPaymentError = () => {
    _sendPurchaseEventByNewRelic('fail', null, 'setPayment');
    TagManagerService.interaction('Problema al seleccionar método de pago', '500 VTEX', 'Errores payment');
}

const setClientProfile = (data) => {
    const orderFormId = StorageService.getItem('orderFormId');
    return fetch(api.orderForm + `/orderform/${orderFormId}/clientProfileData`, {
        headers: {
            'x-api-key': api.apiKey,
            'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(data),
    }).then(results => results.json())
        .catch(() => {
            PubSub.dispatch('error_503');
            return false
        });
}

const getAllOrderFormStatus = (orderForm) =>{
    const payment = getStatusPaymentData(orderForm);
    const userData = getStatusUserData(orderForm);
    const shippingData = getStatusShippingData(orderForm);
    const salesChannel = getStatusSalesChannel(orderForm);

    return payment && userData && shippingData && salesChannel;
}

const getStatusSalesChannel = (orderForm) => {
    if(!orderForm) return false;
    const salesChannelValidated = StorageService.getItem('sc_validate');
    const shippingMethod = methodToSla[StorageService.getItem('preselected_shipping_method')];
    return ((shippingMethod && (shippingMethod !== 'Despacho a Domicilio' && shippingMethod !== 'Express')) || orderForm.salesChannel !== '11' || salesChannelValidated);
}

const getStatusPaymentData = (orderForm) => {
    if(!orderForm) return false;
    const paymentData = orderForm.paymentData;
    return (!!paymentData && !!paymentData.payments && paymentData.payments.length > 0);
}

const getStatusUserData = (orderForm) => {
    if(!orderForm) return false;
    const clientProfileData = orderForm.clientProfileData;
    return (!!clientProfileData && !!clientProfileData.document && !!clientProfileData.email && !!clientProfileData.phone);
}

const getStatusShippingData = (orderForm) => {
    if(!orderForm) return false;

    const shipping = orderForm.shippingData;
    //const deliveryT = StorageService.getItem('preselected_shipping_method');
    //SalesChannel.getMethodName(sellerId);
    const addressSelected = StorageService.getItem('addressSelected');

    let selectedSla = null;
    let sellers = ProductFactory.splitItems(orderForm.items, false);

    const valid = sellers && sellers.map((seller)=> {
        const logistics = getLogisticsOF(orderForm, seller.id);
        const deliveryT = SalesChannel.getMethodName(seller.id);
        if(logistics){
            selectedSla = logistics[0].selectedSla;
            const sla = logistics[0].slas.filter(item => item.id === selectedSla);
            const address = shipping.address;

            return (!!selectedSla && sla.length > 0 && addressSelected && ((!!sla[0].deliveryWindow && deliveryT !== 'seller-1-sla-Express') || (expressFlag && (selectedSla === 'Despacho Express') && (deliveryT === 'seller-1-sla-Express'))) && !!address.receiverName);
        }
        return false
    }).filter(Boolean);

    const quantity = orderForm.items.reduce(function (oldValue, item) {
        return oldValue + item.quantity;
    }, 0);


    if(selectedSla === 'Despacho Express'){
        return valid.length && (maxItemsExpress >= quantity)
    }
    return valid.length === sellers.length;
}

const getSlasOF = (orderForm, seller, addressId = false) => {

    const logistics = getLogisticsOF(orderForm, seller);

    if(!(logistics && logistics[0])) return [];

    return logistics[0].slas.map(sla => {
        if(addressId && sla.id.includes(addressId)){
            return sla;
        }else{
            return false
        }
    }).filter(Boolean);
}

const getLogisticsOF = (orderForm, seller) => {
    if(!(orderForm && orderForm.shippingData && orderForm.items)) return false;

    let logistics = orderForm.shippingData.logisticsInfo ? [...orderForm.shippingData.logisticsInfo] : [];
    let items = orderForm.items ? [...orderForm.items] : [];
    items = items.filter(item => item.seller === seller);
    logistics = logistics.filter(logistic => {
        const itemIndex = items.findIndex(item => item.id == logistic.itemId)
        return (itemIndex !== -1)
    });
    return logistics;
}

const getDeliveryWindow = (orderForm,method,sellerId, addressId) => {
    if(!(orderForm && orderForm.shippingData && orderForm.shippingData.logisticsInfo)) return false;
    const logistics = CartService.getLogisticsOF(orderForm, sellerId);
    let sla = AddressFactory.getSla(logistics, method, addressId);
    return (sla && sla.length)  ? sla[0].deliveryWindow : null;
}


const formatDate = (deliveryWindow) => {
    const dayName = Day(deliveryWindow.startDateUtc).locale('es').format('ddd DD');

    let newDay = dayName.charAt(0).toUpperCase() + dayName.slice(1).replace('.', '');

    const month = Day(deliveryWindow.startDateUtc).locale('es').format('MM');

    const newMonth = month.charAt(0).toUpperCase() + month.slice(1);
    const startDate = Day.extend(utc)(deliveryWindow.startDateUtc).utc().format('HH:mm');
    const endDate = Day.extend(utc)(deliveryWindow.endDateUtc).utc().format('HH:mm');

    return newDay + '/' + newMonth + ' ' +  startDate + ' hrs a '  + endDate + ' hrs';
}

const addProductsByUrl = (search, replaceUrl) => {
    let params = new URLSearchParams(search);
    let skus = params.get('sku');

    if(!skus) return false;

    skus = skus.split(',');

    let quantities = params.get('quantity');
    if(quantities){
        quantities = quantities.split(',');
    }
    let sellers = params.get('seller');
    if(sellers){
        sellers = sellers.split(',');
    }

    let listProducts = skus.map((sku, i) => {
        return {
            id: sku,
            quantity: (quantities && quantities[i]) ? quantities[i] : 1,
            seller: (sellers && sellers[i]) ? sellers[i] : 1
        }
    });

    if(listProducts.length){
        CartActions.addItems(listProducts).then((response) => {
            if(response){
                PubSub.dispatch('toggle_minicart', { state: true });
                replaceUrl('/');
            }
        })
    }

}

const fixSalesChannel = (orderForm) => {
    const {geoCoordinates} = orderForm.shippingData.address;

    return AddressService.getSalesChannel(geoCoordinates[1], geoCoordinates[0]).then(data => {
        if(data && parseInt(orderForm.salesChannel) === data.sc){
            return true;
        } else {
            return applyingSourceApp(data.sc).then(dataSourceApp => {
                if(dataSourceApp && parseInt(dataSourceApp.salesChannel) === data.sc){
                    return CartActions.updateOrderForm(dataSourceApp);
                } else {
                    return false;
                }
            })
        }
    });
}

const CartService = {
    getCurrentCart,
    getOldAddress,
    validateAddress,
    changeOrdination,
    initOrderForm,
    getOrderForm,
    getOldOrderForm,
    addItems,
    updateQuantity,
    removeItem,
    emptyCart,
    purchase,
    getPaymentURL,
    shippingEstimate,
    clearLogisticInfo,
    applyingMethodInLogisticInfo,
    updateShippingData,
    updateOrderForm,
    setCupon,
    goToCheckout,
    applySalesChannel,
    applyAddressSC,
    applyingSourceApp,
    sendMail,
    getOrderInfo,
    setOrderInfo,
    setPayment,
    setClientProfile,
    getAllOrderFormStatus,
    getStatusPaymentData,
    getStatusUserData,
    getStatusShippingData,
    _expressTime,
    getSlasOF,
    getLogisticsOF,
    getDeliveryWindow,
    formatDate,
    addProductsByUrl,
    getStatusSalesChannel,
    fixSalesChannel,
    dispatchModalNote
};

if (typeof window !== 'undefined') {
    window.chatbot = {
        addToCart: (skuId, quantity) => {
            const addItemsPromise = CartService.addItems([{
                id: skuId,
                quantity
            }]);

            PubSub.dispatch('cart_productAdd', { promise: addItemsPromise });
        }
    }
}

export default CartService;
